type GalleryThumb = {
  is_cover: boolean
  thumb_url: string
  thumb_webp_url?: string | null
}

export type PropertyCardImageSource = {
  cover_url?: string | null
  cover_webp_url?: string | null
  gallery?: GalleryThumb[]
}

export type PropertyCardImage = {
  jpeg: string | null
  webp: string | null
}

function nonempty(value: string | null | undefined): string | null {
  const trimmed = value?.trim()
  return trimmed ? trimmed : null
}

/** Card/recap cover: 480px JPEG + matching WebP. Never `gallery[].url` (full-size). */
export function propertyCardImage(property: PropertyCardImageSource): PropertyCardImage {
  const cover = property.gallery?.find((item) => item.is_cover) ?? property.gallery?.[0]

  return {
    jpeg: nonempty(cover?.thumb_url) ?? nonempty(property.cover_url),
    webp: nonempty(property.cover_webp_url) ?? nonempty(cover?.thumb_webp_url),
  }
}
